// removed by extract-text-webpack-plugin
module.exports = {"transaction-summary-modal-content":"transaction-summary-modal-content","transaction-receipt":"transaction-receipt","input-group":"input-group"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/TransactionSummary/Modal.scss
// module id = BneF
// module chunks = 0